/**
 * План магазина со шкафами: подписи шкафов и координаты на плане.
 *
 * Координаты шкафа — доли ширины и высоты плана (0…1): от размера
 * картинки и экрана они не зависят.
 */

/** Значение в пределах 0…1. */
export const clamp01 = (v) => Math.min(1, Math.max(0, v));

/**
 * Короткая подпись шкафа на плане: «Шкаф коммутационный S2» → «S2»,
 * «ШК-3» → «ШК-3». Полное название — во всплывающей подсказке.
 */
export function shortCabinetName(name) {
  const s = String(name || '').trim();
  const code = s.match(/(?:^|\s)([A-Za-zА-Яа-яЁё]{0,4}-?\d+[A-Za-zА-Яа-яЁё]?)$/);
  if (code) return code[1];
  if (s.length <= 8) return s;
  return `${s.slice(0, 7)}…`;
}

/** Точка нажатия → доли плана. rect — getBoundingClientRect() плана. */
export function pointToPlan(clientX, clientY, rect) {
  return {
    x: clamp01((clientX - rect.left) / rect.width),
    y: clamp01((clientY - rect.top) / rect.height),
  };
}

/** Шкафы, которых нет ни на одном плане объекта. */
export function unplacedCabinets(cabinets, plans) {
  const placed = new Set(plans.flatMap((p) => p.markers.map((m) => m.cabinetId)));
  return cabinets.filter((c) => !placed.has(c.id));
}

/** На каком плане стоит шкаф: { plan, marker } или null. */
export function findMarker(plans, cabinetId) {
  for (const plan of plans) {
    const marker = plan.markers.find((m) => m.cabinetId === cabinetId);
    if (marker) return { plan, marker };
  }
  return null;
}
